/**
 * Animations from from https://easings.net/
 * Interpolate values from [0.0, 1.0], on animation curve
 */

export function easeOutCubic(x: number): number {
  return 1 - (1 - x) ** 3;
}
